import styled from "styled-components";

import RadiusInput from "./components/RadiusInput";
import RadiusSelector from "./components/RadiusSelector";
import { useXdaProjectionOptions } from "./hooks/useXdaProjectionOptions";

// Re-export for backward compatibility
export {
  XDA_DIMENSION_KEYS,
  XDA_PROJECTION_RADIUS_TYPES,
  XDA_RADIUS_KEYS
} from "./hooks/useXdaProjectionOptions";

const XdaRadiusGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 5px 0;

  .ant-input {
    width: 100%;
    min-width: 100px;

    &:disabled {
      background-color: var(--color-bg-disabled, #f5f5f5);
      cursor: not-allowed;
    }
  }
`;

export default function XdaProjectionOptions() {
  const {
    selectedRadius,
    isCustomRadius,
    jobRadiusOptions,
    xdaDimensions,
    displayLabel,
    metersToDisplay,
    displayToMeters,
    isReady,
    handleRadiusChange,
    updateDimension
  } = useXdaProjectionOptions();

  return (
    <>
      <div className="separator" />
      <div className="ipdb-option-item">
        <XdaRadiusGrid>
          <RadiusSelector
            value={selectedRadius}
            onChange={handleRadiusChange}
            jobRadiusOptions={jobRadiusOptions}
          />
          <RadiusInput
            label="Left"
            displayLabel={displayLabel}
            metersValue={xdaDimensions.leftWidth}
            disabled={!isCustomRadius}
            metersToDisplay={metersToDisplay}
            displayToMeters={displayToMeters}
            isReady={isReady}
            onChange={(value) => updateDimension("leftWidth", value)}
          />
          <RadiusInput
            label="Right"
            displayLabel={displayLabel}
            metersValue={xdaDimensions.rightWidth}
            disabled={!isCustomRadius}
            metersToDisplay={metersToDisplay}
            displayToMeters={displayToMeters}
            isReady={isReady}
            onChange={(value) => updateDimension("rightWidth", value)}
          />
        </XdaRadiusGrid>
      </div>
    </>
  );
}
